import { render, staticRenderFns } from "./custom-buygoods.vue?vue&type=template&id=2c9b919f"
import script from "./custom-buygoods.vue?vue&type=script&lang=js"
export * from "./custom-buygoods.vue?vue&type=script&lang=js"
import style0 from "./custom-buygoods.vue?vue&type=style&index=0&id=2c9b919f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports